import { FC, useState } from "react";
import "./CommunityOutreach.scss";

interface ICommunityOutreachProps {
  name: string;
  logo: string;
  content: string;
  link: string;
}

export const CommunityOutreach: FC<ICommunityOutreachProps> = ({
  name,
  logo,
  content,
  link,
}) => {
  const [Logo, setLogo] = useState<string>(
    require(`../../../assets/${logo}`).default
  );
  return (
    <div className="CommunityOutreach">
      <img
        className={`CommunityOutreach__logo CommunityOutreach__logo__${name.replace(
          /\s/g,
          ""
        )}`}
        src={Logo}
        alt={name}
      />
      <div className="CommunityOutreach__link">
        <a href={link} target="_blank" rel="noopener noreferrer">
          <p className="CommunityOutreach__name">{name}</p>
          <i className="fa fa-arrow-right"></i>
        </a>
      </div>
      <p className="CommunityOutreach__content">{content}</p>
    </div>
  );
};
